var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHereIco16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60328 7.64701C9.79851 7.84225 9.79851 8.15931 9.60328 8.35455L7.10425 10.8536C6.90902 11.0488 6.59195 11.0488 6.39672 10.8536C6.20148 10.6583 6.20148 10.3413 6.39672 10.146L8.54275 8L6.39828 5.85396C6.20304 5.65873 6.20304 5.34166 6.39828 5.14643C6.59352 4.95119 6.91058 4.95119 7.10581 5.14643L9.60484 7.64545L9.60328 7.64701Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHereIco16);
export default __webpack_public_path__ + "static/media/Here_ico_16.9d9c5777df50365b86e306771dd6282e.svg";
export { ForwardRef as ReactComponent };